import axios from 'axios';
import _ from 'lodash';

import BaseModel from './BaseModel';
import UserModel from './UserModel';
const BASE = BaseModel.getApiBasePath() + '/api/v1/camdetect/messages';

export default new class CamdetectMessagesModel {

    constructor() { }

    get(id) {
        return new Promise((resolve, reject) => {
            this.getAll()
                .then((data) => {
                    resolve(_.find(data.message, { id: id }));
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    getAll(camera, dateFrom = null, dateTo = null) {
        var filter = {
            order: 'timestamp DESC',
            where: {
                and: []
            }
        };
        filter.where.and.push({ cameraId: camera })
        if (dateFrom && dateTo) {
            filter.where.and.push({ timestamp: { gte: dateFrom } });
            filter.where.and.push({ timestamp: { lte: dateTo } });
            filter = _.merge(filter, { include: [{ relation: 'camera' }] });
        }
        return new Promise((resolve, reject) => {
            axios.get(BASE, {
                params: {
                    access_token: UserModel.getAccessToken(),
                    filter: filter
                }
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    create(data) {
        return new Promise((resolve, reject) => {
            axios.post(BASE, data, {
                params: {
                    access_token: UserModel.getAccessToken()
                }
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    remove(id) {
        return new Promise((resolve, reject) => {
            axios.delete(BASE + '/' + id, {
                params: {
                    access_token: UserModel.getAccessToken()
                }
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

}


// WEBPACK FOOTER //
// ./src/components/CamdetectMessagesModel.js